"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resource = exports.RoutesWithLayout = exports.createAdminStore = exports.CoreAdminUI = exports.CoreAdminRouter = exports.CoreAdminContext = exports.CoreAdmin = void 0;
var CoreAdmin_1 = __importDefault(require("./CoreAdmin"));
exports.CoreAdmin = CoreAdmin_1.default;
var CoreAdminContext_1 = __importDefault(require("./CoreAdminContext"));
exports.CoreAdminContext = CoreAdminContext_1.default;
var CoreAdminRouter_1 = __importDefault(require("./CoreAdminRouter"));
exports.CoreAdminRouter = CoreAdminRouter_1.default;
var CoreAdminUI_1 = __importDefault(require("./CoreAdminUI"));
exports.CoreAdminUI = CoreAdminUI_1.default;
var createAdminStore_1 = __importDefault(require("./createAdminStore"));
exports.createAdminStore = createAdminStore_1.default;
var RoutesWithLayout_1 = __importDefault(require("./RoutesWithLayout"));
exports.RoutesWithLayout = RoutesWithLayout_1.default;
var Resource_1 = __importDefault(require("./Resource"));
exports.Resource = Resource_1.default;
